// extracted by mini-css-extract-plugin
export default {"admin-otp-input__wrapper":"OTPInput_admin-otp-input__wrapper__hsJcT","admin-otp-input__field":"OTPInput_admin-otp-input__field__Zbx8-"};